  
// src/utils/loadSanadBranding.js
const { config } = require('../../api/api.js');
// const { sanadURL } = config;
export function loadSanadBranding() {
  // Check if jQuery is already available
  if (typeof window.jQuery === 'undefined') {
    console.error('jQuery is not loaded. Please ensure jQuery is loaded before calling loadSanadBranding.');
    return;
  }

  // Load branding.js only
  const brandingScript = document.createElement('script');
  brandingScript.src = config.sanadURL;
  // brandingScript.src = 'https://nigsoft.com/sanad/branding.js'; // or original source
  // brandingScript.src = 'https://www.smartforms.com.om/smartformsonline/BrandingCSS/branding.js'
  brandingScript.async = false;
  document.body.appendChild(brandingScript);
}
